<template>
    <div class="wrapper">
        <v-main-sidebar></v-main-sidebar>
        <v-minor-sidebar></v-minor-sidebar>
        <v-sidebar></v-sidebar>
        <div class="content-box" :class="{ 'content-collapse': collapse }">
            <v-head></v-head>
            <!--<v-tags></v-tags>-->
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>
<!--                <el-backtop target="content"></el-backtop>-->
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import vHead from '../components/common/Header.vue';
import vMainSidebar from '../components/common/MainSidebar.vue';
import vMinorSidebar from '../components/common/MinorSidebar.vue';
import vSidebar from '../components/common/Sidebar.vue';
import vTags from '../components/common/Tags.vue';
import bus from '../components/common/bus';
import { getUserInfo } from '@/api/user.js';
import {WEBSOCKET_API} from '@/utils/socket/socket_constant.js'
export default {
    data() {
        return {
            tagsList: [],
            collapse: false,
            userInfos: {},
            onlines: '',
            yesNo: false
        };
    },
    components: {
        vHead,
        vMainSidebar,
        vMinorSidebar,
        vSidebar,
        vTags
    },
    created() {
        this.getUserInfo();
        this.getLeftMenuList();
        this.getSysInfo();
        bus.$on('collapse-content', (msg) => {
            this.collapse = msg;
        });
        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', (msg) => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
        console.log(this.reset,"怎么会没有")
    },
    watch:{
        reset(val,old){
            if(val == old){
                return
            }
            if(val){
                this.onlines = setInterval(() => {
                    this.onstoll()
                }, 10000);
            }else{
                clearInterval(this.onlines)
                this.onlines = ''
            }
        }
    },
    mounted(){
        // this.$SOCKET.send(`{"actionType":1,"deviceType":1,"message":{"messageType":1,"senderId":"${this.userInfo.id}","message":"${localStorage.getItem("token")}"}}`)
    },
    computed:{
        ...mapState(['userInfo']),
        reset(){
            console.log(this.$store.state.newChat.protectThread,'保护线程')
            return this.$store.state.newChat.protectThread
        }
    },
    beforeDestroy(){
        this.$store.commit('newChat/SetProtectThread',false);
        clearInterval(this.onlines)
        this.onlines = ''
    },
    methods: {
        ...mapMutations(['setUserInfo']),
        // ...mapMutations('newChat',['changeCurrentSession']),
        ...mapActions(['getLeftMenuList']),
        ...mapActions(['getSysInfo']),
        getUserInfo() {
            getUserInfo().then((res) => {
                if(res.success){
                    this.setUserInfo({ data: res.user });
                    this.userInfos = res.user;
                    this.onstoll()
                }
            });
        },
        onstoll(){
            let obj = {
                sockeUrl:WEBSOCKET_API,
                onErrorEvent:this.onErrorEvent,
                onSucceedEvent:this.onSucceedEvent,
                onUserInfo:JSON.parse(JSON.stringify(this.userInfos)),
                router: this.$router
            }
            let sender = {
                headImage: this.userInfos.userHeader,
                nickName: this.userInfos.userNickname,
                senderId: this.userInfos.id,
            }
            localStorage.setItem(`sender`,JSON.stringify(sender));
            this.$store.dispatch('newChat/socket',obj)
        },
        onSucceedEvent(val) {
            // console.log("777",val)
            // this.$message.warning(val);
        },
        onErrorEvent(val) {
            // console.log("888",val)
            // this.$message.error(val);
        },
    }
};
</script>
